<template lang="pug">
  .database-list
    .overlay(v-if="isSpinner")
      v-layout(row justify-center align-center fill-height)
        v-progress-circular(
          :size="50"
          :width="3"
          color="primary"
          indeterminate)
    v-card-title
      h3 Базы данных
    v-card-text
      v-layout(row justify-center).pb-4
        v-flex(xs11 sm9 md8)
          v-data-table(
            :headers="headers"
            :items="databaseList"
            no-data-text="Нет данных для отображения"
            hide-actions)
            template(slot="items" slot-scope="props")
              td {{ props.index + 1 }}
              td(@click.prevent="viewDatabase(props.item.id, props.item.name)") {{ props.item.name }}
              td
                a(@click.prevent="viewDatabase(props.item.id, props.item.name)") Просмотреть
    DataBaseView(:isShow="isDialogViewDb", :id="dbId", :name="dbName", @close-dialog="closeDialogViewDb")
</template>
<script>
import DataBaseView from '@/components/DataBase//DataBaseView'
export default {
  components: { DataBaseView },
  data: () => ({
    dbId: '',
    dbName: '',
    isDialogViewDb: false,
    headers: [
      { text: '№', value: 'id', sortable: false },
      { text: 'Название БД', value: 'name' },
      { text: 'Действие', value: 'action', sortable: false }
    ],
    isSpinner: false
  }),
  mounted() {
    this.$store.dispatch('GET_DB_LIST_NOT_NULL_SCHEMA')
  },
  computed: {
    databaseList() {
      return this.$store.state.constructor.dbList
    }
  },
  methods: {
    viewDatabase(id, name) {
      this.isSpinner = true
      this.$store.dispatch('GET_DB_RECORDS_LIST', { id: id }).then(() => {
        this.dbName = name
        this.dbId = id
        this.isSpinner = false
        this.isDialogViewDb = true
      })
    },
    closeDialogViewDb(value) {
      this.isDialogViewDb = value
    }
  }
}
</script>
<style lang="scss" scoped>
#app .v-card {
  .v-toolbar {
    .v-btn {
      margin: 0;
    }
  }
}
.overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DataBase/DataBaseList.vue